<template>
    <div class="header-container">
        <Header />
    </div>
    <div class="content-container">
        <router-view />
    </div>
    <div class="footer-container">
        <Footer />
    </div>
</template>

<script>
import Header from './views/header/header.vue';
import Footer from './views/footer/footer.vue';

export default {
    name: 'App',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            currentLanguage: 'en'
        }
    },
    methods: {
        changeLanguage(event) {
            const newLang = event.target.value
            this.currentLanguage = newLang
            this.$i18n.locale = newLang

            // Get current path segments
            const pathSegments = this.$route.path.split('/')
            const currentPage = pathSegments[2] || ''

            // Define route mappings for each language
            const routeMappings = {
                'contact': {
                    'en': 'contact',
                    'sk': 'kontakt',
                    'de': 'kontakt',
                    'pl': 'kontakt',
                    'hu': 'kapcsolat'
                },
                'about': {
                    'en': 'about',
                    'sk': 'o-nas',
                    'de': 'uber-uns',
                    'pl': 'o-nas',
                    'hu': 'rolunk'
                },
                'apartments': {
                    'en': 'apartments',
                    'sk': 'apartmany',
                    'de': 'apartments',
                    'pl': 'apartamenty',
                    'hu': 'apartmanok'
                },
                'gallery': {
                    'en': 'gallery',
                    'sk': 'galeria',
                    'de': 'galerie',
                    'pl': 'galeria',
                    'hu': 'galeria'
                },
                'tips': {
                    'en': 'tips',
                    'sk': 'tipy',
                    'de': 'tipps',
                    'pl': 'porady',
                    'hu': 'tippek'
                }
            }

            // Find current page key by checking all possible routes
            let currentPageKey = ''
            for (const [key, translations] of Object.entries(routeMappings)) {
                if (Object.values(translations).includes(currentPage)) {
                    currentPageKey = key
                    break
                }
            }

            // Construct new path
            const newPath = currentPageKey
                ? `/${newLang}/${routeMappings[currentPageKey][newLang]}`
                : `/${newLang}`

            this.$router.push(newPath)
        }
    },
    created() {
        // Set initial language based on route
        const lang = this.$route.path.split('/')[1] || 'en'
        this.currentLanguage = lang
        this.$i18n.locale = lang
    }
}
</script>

<style>
@import '@/assets/style.css';

#app {
    position: relative;
    min-height: 100vh;
    width: 100%;
    min-width: 320px; /* Reduced minimum width */
    display: flex;
    flex-direction: column;
    overflow-x: auto; /* Allow horizontal scrolling if needed */
    background-color: whitesmoke;
}

/* Add styles for better mobile handling */
@media screen and (max-width: 374px) {
    #app {
        font-size: 14px; /* Slightly reduce base font size */
    }
}

.header-container {
    position: relative;
    z-index: 100;
}

.content-container {
    flex: 1;
    padding-bottom: 20em; /* Add space for footer */
    min-height: calc(100vh - 80px); /* Subtract header height */
    margin-top: 8em; /* Add margin for fixed header */
}

.footer-container {
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 99;
}

</style>